import type { CustomerProductFileType } from "./types"

import { ApprovalStatus, ComputedProductStatus, FieldGroupEnum, PriorityStatus } from "@/graphql/codegen/graphql"
import {
  FileTypeToChipColorMap,
  ProductFileType,
} from "@/screens/Products/components/Product/Information/types/productFile"
import type { AssociateProductFormValues } from "@/screens/Products/schemas/associateProductForm"
import type { Option } from "@/types/form-fields"

export const EMPTY_LOCATION = {
  shipToLocationId: "",
  customerCode: [] as string[],
  priorityStatus: null,
  approvalStatus: null,
} satisfies AssociateProductFormValues["locations"][number]

export const COMPUTED_STATUS_LIST: ComputedProductStatus[] = [
  ComputedProductStatus.Active,
  ComputedProductStatus.Discontinued,
  ComputedProductStatus.PendingApproval,
]

export const PRIORITY_STATUS_LABELS: Record<PriorityStatus, string> = {
  [PriorityStatus.Primary]: "Primary",
  [PriorityStatus.Alternate]: "Alternate",
  [PriorityStatus.DoNotUse]: "Do Not Use",
}

export const PRIORITY_STATUS_CLASS_MAP: Record<PriorityStatus, string> = {
  [PriorityStatus.Primary]: "bg-tertiary-green-100",
  [PriorityStatus.Alternate]: "bg-tertiary-yellow-100",
  [PriorityStatus.DoNotUse]: "bg-secondary-100",
}

export const PRIORITY_STATUS_OPTIONS: readonly Option<PriorityStatus>[] = [
  { value: PriorityStatus.Primary, label: "Primary" },
  { value: PriorityStatus.Alternate, label: "Alternate" },
  { value: PriorityStatus.DoNotUse, label: "Do Not Use" },
] as const

export const APPROVAL_STATUS_OPTIONS: readonly Option<ApprovalStatus>[] = [
  { value: ApprovalStatus.Approved, label: "Approved" },
  { value: ApprovalStatus.Pending, label: "Pending" },
  { value: ApprovalStatus.Rejected, label: "Rejected" },
  { value: ApprovalStatus.DoNotShip, label: "Do Not Ship" },
  { value: ApprovalStatus.Sampled, label: "Sampled" },
] as const

export const APPROVAL_STATUS_LABELS: Record<ApprovalStatus, string> = {
  [ApprovalStatus.Approved]: "Approved",
  [ApprovalStatus.Pending]: "Pending",
  [ApprovalStatus.Rejected]: "Rejected",
  [ApprovalStatus.DoNotShip]: "Do Not Ship",
  [ApprovalStatus.Sampled]: "Sampled",
}

export const APPROVAL_STATUS_CHIP_CLASS_MAP: Record<ApprovalStatus, string> = {
  [ApprovalStatus.Approved]: "border-tertiary-green-300",
  [ApprovalStatus.Pending]: "border-tertiary-orange-500",
  [ApprovalStatus.Rejected]: "border-secondary",
  [ApprovalStatus.DoNotShip]: "border-secondary",
  [ApprovalStatus.Sampled]: "border-primary",
}

export const CUSTOMER_PRODUCT_FILE_FIELD_GROUPS: CustomerProductFileType[] = [
  FieldGroupEnum.ProductCoa,
  FieldGroupEnum.ProductSds,
  FieldGroupEnum.ProductTds,
]

export const CUSTOMER_PRODUCT_FILE_TYPE_MAPPING: Record<CustomerProductFileType, { label: string; color: string }> = {
  [FieldGroupEnum.ProductCoa]: FileTypeToChipColorMap[ProductFileType.COA],
  [FieldGroupEnum.ProductSds]: FileTypeToChipColorMap[ProductFileType.SDS],
  [FieldGroupEnum.ProductTds]: FileTypeToChipColorMap[ProductFileType.TDS],
}
